import './main-header.scss';

import SearchComponent from '../search/search';
import NavigationComponent from '../navigation/navigation';
import bodymovin from 'lottie-web';

const MainHeaderComponent = {
  el: null,

  init() {
    this.el = document.querySelector('#main-header');

    SearchComponent.init();
    NavigationComponent.init();

    //this.buildLogo();
  },

  buildLogo() {
    let logoRef = this.el.querySelectorAll('.main-header__logo')[0];

    var poop = bodymovin.loadAnimation({
      autoplay: true,
      container: logoRef, // Required
      path: '/dist/animations/logo_buildin.json', // Required
      renderer: 'svg',
      name:'main-header-logo'
    });
  }
};

export default MainHeaderComponent;
